import Login from '@/views/login/index'

export default [
  {
    path: '/',
    meta: { layout: 'Home', pageType: 'protected' },
    children: [
      {
        path: '',
        redirect: 'login'
      },
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: { title: '用户登录' }
      },

      {
        path: 'forget',
        name: 'Forget',
        component: () => import('@/views/forget.vue'),
        meta: {
          title: '忘记密码',
          index: 4
        }
      },

      {
        path: 'reset',
        name: 'Reset',
        component: () => import('@/views/reset.vue'),
        meta: {
          title: '重置密码',
          index: 5
        }
      },

      {
        path: 'bind',
        name: 'Bind',
        component: () => import('@/views/bind'),
        meta: {
          title: '微信绑定',
          index: 4
        }
      },

      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/register/index.vue'),
        meta: {
          title: '注册',
          workbenchTitle: '注册',
          layout: 'Layout',
          index: 3
        }
      },

      {
        path: 'third-access/:from?/:to?',
        name: 'ThirdAccess',
        component: () => import('@/views/login/third-access.vue'),
        meta: {
          title: '第三方跳转',
          pageType: 'public',
          layout: 'Layout',
          index: 3
        }
      },

      // 认证企业
      {
        path: 'cert/:new?/select',
        name: 'SelectService',
        component: () => import('@/views/enterprise-cert/select-service'),
        meta: {
          title: '选择身份',
          workbenchTitle: '主体认证',
          pageType: 'private',
          layout: 'Layout',
          index: 3
        }
      },
      {
        path: 'cert/:service?/:new?/form',
        name: 'CertForm',
        component: () => import('@/views/enterprise-cert/cert'),
        meta: {
          title: '认证主体',
          workbenchTitle: '主体认证',
          pageType: 'private',
          layout: 'Layout',
          index: 3
        }
      },

      // 平台选择
      {
        path: 'login/navigate',
        name: 'LoginNavigate',
        component: () => import('@/views/login/navigate.vue'),
        meta: {
          title: '工作台登录',
          pageType: 'private',
          layout: 'NoLayout'
        }
      },

      // 信息核验
      {
        path: 'message-verification',
        name: 'MessageVerification',
        component: () => import('@/views/message-verification/index.vue'),
        meta: {
          title: '信息核验',
          pageType: 'public',
          layout: 'NoLayout'
        }
      }
    ]
  }
]
